<div class="empty-state text-center">
  <i class="icon" [class]="icon"></i>
  <h4 class="mt-3">{{title}}</h4>
  <p class="text-secondary">{{description}}</p>
</div>